// extracted by mini-css-extract-plugin
export default {"wrapper":"ui_wrapper__HiXKO","wrapperLoader":"ui_wrapperLoader__TfYvx","checkSignSuccess":"ui_checkSignSuccess__yikuT"};